import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessageModule } from 'primeng/message';
import { QrCodeComponent } from 'ng-qrcode';
import { MfaSetupResponseDto } from '@qc/shared/dto';

@Component({
    selector: 'qc-totp-setup',
    standalone: true,
    imports: [CommonModule, ButtonModule, ProgressSpinnerModule, MessageModule, QrCodeComponent],
    template: `
        <div class="p-4">
            <h2 class="text-lg font-bold text-center mb-4">Set Up Authenticator App</h2>

            <p-message *ngIf="error" severity="error" [text]="error" styleClass="w-full mb-4 block"></p-message>

            <div *ngIf="!error">
                <ol class="mb-6 space-y-2 opacity-50 ">
                    <li class="flex gap-2 items-center">
                        <span
                            class="flex items-center justify-center rounded-full bg-neutral-100 w-6 h-6  flex-shrink-0"
                            >1</span
                        >
                        <span
                            >Install an authenticator app like Google Authenticator, Microsoft Authenticator, or
                            Authy.</span
                        >
                    </li>
                    <li class="flex gap-2 items-center">
                        <span
                            class="flex items-center justify-center rounded-full bg-neutral-100 w-6 h-6  flex-shrink-0"
                            >2</span
                        >
                        <span>Scan the QR code below or enter the secret key manually.</span>
                    </li>
                    <li class="flex gap-2 items-center">
                        <span
                            class="flex items-center justify-center rounded-full bg-neutral-100 w-6 h-6  flex-shrink-0"
                            >3</span
                        >
                        <span>Enter the 6-digit code displayed in your app to verify.</span>
                    </li>
                </ol>

                <div *ngIf="setupData?.otpAuthUri" class="flex flex-col items-center justify-center mb-6">
                    <div class="border border-gray-300 p-1 rounded bg-white mb-2">
                        <qr-code [value]="setupData?.otpAuthUri || ''" [size]="200"></qr-code>
                    </div>

                    <div class=" text-gray-600 mt-2">
                        Secret key:
                        <span class="font-mono bg-gray-100 p-1 rounded">{{ setupData?.secretKey || '' }}</span>
                    </div>
                </div>

                <div *ngIf="isLoading" class="flex justify-center my-4">
                    <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
                </div>

                <p-button
                    type="button"
                    label="Continue to Verification"
                    icon="pi pi-arrow-right"
                    styleClass="w-full mt-4"
                    size="large"
                    [disabled]="isLoading || !setupData"
                    (click)="continueToVerification.emit()"
                />
            </div>

            <div *ngIf="error" class="mt-4">
                <p-button
                    type="button"
                    label="Try Another Method"
                    icon="pi pi-arrow-left"
                    class="w-full"
                    (click)="tryAnotherMethod.emit()"
                ></p-button>
            </div>
        </div>
    `,
})
export class TotpSetupComponent {
    @Input() setupData: MfaSetupResponseDto | null = null;
    @Input() isLoading: boolean = false;
    @Input() error: string = '';

    @Output() continueToVerification = new EventEmitter<void>();
    @Output() tryAnotherMethod = new EventEmitter<void>();
}
